var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      _vm.currentRoute !== 'not_found' &&
      _vm.currentRoute !== 'subscription_success' &&
      _vm.currentRoute !== 'subscription_invoice'
    )?_c('div',[_c('Sidenav',{attrs:{"is_sidebar_open":_vm.isSidebarOpen}}),_c('Header',{on:{"toggleSidebar":(value) => (_vm.isSidebarOpen = value)}}),_c('div',{staticClass:"pcoded-main-container overflow-hidden"},[_c('div',{staticClass:"pcoded-content"},[_c('div',{staticClass:"main-body"},[(_vm.isOnline)?_c('router-view'):_c('OfflineComponent')],1)])])],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }